import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import META from './useTrackCaptionGenerationFailed.meta';

export type UseTrackCaptionGenerationFailedParams = {
  video_id: string;
  error_type: string;
};

export const useTrackCaptionGenerationFailed = () => {
  const { track } = useAnalyticsUtilities();

  const trackCaptionGenerationFailed = useCallback(
    (params: UseTrackCaptionGenerationFailedParams) => {
      track(META.name, params);
    },
    [track],
  );

  return { trackCaptionGenerationFailed };
};
